export const ADD_SOCIAL_NETWORK = 'ADD_SOCIAL_NETWORK';



// WEBPACK FOOTER //
// ./src/store/SocialMedia/types.js